export function fnMenuFlag(array,str,isRoot){
    if (isRoot){
        return true;
    }else {
        return array.includes(str);
    }
}

export function getItemIndex(array,item) {
    for (let i = 0; i <array.length ; i++) {
        if (item.userId === array[i].userId){
            return i;
        }
    }
    return -1;
}